<div class="filter-label mt-2 ">
    <label title="{{props['fieldDescription']}}" class="field-label {{ getStatus() }} {{ getFilterFontStatus() }}"
        *ngIf="props.label" [attr.id]="id + '-label'" (click)="conmuteHide()">
        {{ props.label }}
    </label>
</div>
<div *ngIf="!this.hide" class="filter-container">
    <div *ngIf="false" class="filter-description">
        <span class="field-description">{{ props.fieldDescription }}</span>
    </div>

    <div class="filter-content">
        <div class="filter-toolbar">
            <button type="button" class="btn btn-light" aria-label="Refresh filter options"
                title="Refresh filter options" [disabled]="this.loading" (click)="refresh()">{{this.getLoadLabel()}}</button>
            <button type="button" class="btn btn-light" aria-label="Clear selected options"
                title="Clear selected options" [disabled]="this.loading" (click)="clear()">Clear</button>
            <button *ngIf="showCode" type="button" [disabled]="this.loading" class="btn btn-light"
                aria-label="Order by {{allowedOrderField()}}" title="Sort alphabetically"
                (click)="order(allowedOrderField())"><span
                    class="bi bi-sort-alpha-down"></span>&nbsp;{{allowedOrderField()}}</button>
        </div>
        
        <div *ngIf="this.loading">
            <app-loading customPositonClass="wrap-container-centered" loadingMessage="Loading Filter"/>
        </div>

        <div *ngIf="!this.loading">
            <div class="two-columns">
                <select *ngIf="this.showSearchField" name="operator" class="form-select" (change)="setOperator($event)"
                    [multiple]="false" type="text">
                    <option value="eq" [selected]="this.formControl.parent!.get('operator')?.value === 'eq'"
                        title="Any column content has the exact provided value">Match</option>
                    <option value="sw" [selected]="this.formControl.parent!.get('operator')?.value === 'sw'"
                        title="Any column content starts with the provided value">Starts with</option>
                    <option value="cn" [selected]="this.formControl.parent!.get('operator')?.value === 'cn'"
                        title="Any column content includes the provided value">Contains</option>
                    <option value="ew" [selected]="this.formControl.parent!.get('operator')?.value === 'ew'"
                        title="Any column content ends with the provided value">Ends with</option>
                    <option value="in" [selected]="this.formControl.parent!.get('operator')?.value === 'in'"
                        title="Any column content has the exact value(s) provided and separated by vertical bar symbol">
                        With</option>
                </select>
                <input *ngIf="this.showSearchField" class="form-control"
                    [placeholder]="props['searchPlaceholder'] || 'Write and Press Enter'"
                    [formControl]="this.formControl.parent!.get!('term')" (keydown.enter)="onEnter()" type="text" />
            </div>

            <select class="form-control" [formControl]="formControl" [multiple]="true" type="text"
                (ngModelChange)="updateCheckbox()">
                <option *ngFor="let opt of datasource; trackBy: trackByCode" [ngValue]="opt.code">
                    {{ opt.name }}
                </option>
            </select>
        </div>
    </div>
</div>